import logger from '../Service/Logger';

export default function useLogger() {
  return logger;
}
